import { SectionItem } from '@features/shift-post-v2/components'
import { connect } from 'formik'
import { ShiftPostStep } from '@src/features/shift-post-v2/steps/steps.types'
import { Text, Colors, InputV2 } from '@pinchenterprisesnpm/friday-ui'
import AuthService from '@src/helpers/authService'
import { CustomValidationError } from '@src/components/common/style'
import { EditNumberModal } from '@src/features/shift-post-v2/steps/shift-details-step/components/shift-identifier-section/edit-numbers-modal'
import { useModal } from '@src/hooks/useModal'
import { IShiftIdentifierSectionProps } from './shift-identifier-section.types'

export const ShiftIdentifierSection = connect<IShiftIdentifierSectionProps>(
  ({ formik, sourceStep }) => {
    const [isOpen, toggleModal, closeModal] = useModal()
    const businessEntity = AuthService.getBusinessEntity()
    const isConfirmStep = sourceStep === ShiftPostStep.CONFIRM

    const {
      values: { gig_identifier },
      errors,
    } = formik

    // Only show this section if the business entity has gig identifier policy enabled
    if (!businessEntity?.enabled_gig_identifier_policy) {
      return null
    }
    /**
     * Leavinvg this like this because the title might change in the future
     */
    const title = isConfirmStep
      ? 'Shift Identifier Numbers'
      : 'Shift Identifier Numbers:'

    return (
      <SectionItem title={title} hasEdit={isConfirmStep} onEdit={toggleModal}>
        {isConfirmStep ? (
          <>
            <Text fontSize="medium" mt="xs" mb="xs" color={Colors.dark}>
              {gig_identifier ||
                'You have not entered any shift identifier numbers yet.'}
            </Text>

            <CustomValidationError>
              {errors.gig_identifier}
            </CustomValidationError>
          </>
        ) : (
          <InputV2
            value={gig_identifier || ''}
            placeholder="Shift Identifier Numbers"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              formik.setFieldValue('gig_identifier', e.target.value)
            }}
            errorMessage={errors.gig_identifier}
            isRequired
          />
        )}

        <EditNumberModal
          isOpen={isOpen}
          closeModal={closeModal}
          formik={formik}
        />
      </SectionItem>
    )
  },
)
